<template>
  <div>      
    <v-slider color="transparent"  :thumb-color="endMissionMode?'secondary':'primary'" class="mx-2 my-0" hide-details ref="slider"  thumb-label thumb-size="22" :value="currentValue" @input="changeValue" :min="0" :max="dates.length > 0?dates.length-1:0" step=1 >
      <template slot="thumb-label" slot-scope="props">
        <span>
          {{ cycles[props.value] }}
        </span>
      </template>        
    </v-slider>        
    <v-layout v-show="true" caption mx-1 pa-0 justify-center>      
      <v-btn class="mx-0" @click="isPlaying = !isPlaying" :disabled="currentValue == dates.length-1" small icon :title="$t('Pilot.MissionDrawer.PlayMissionTooltip')"><v-icon v-html="isPlaying?'mdi-pause':'mdi-play'" ></v-icon></v-btn>
      <v-btn class="mx-0" @click="isPlaying = true" v-if="!isPlaying && currentValue == dates.length-1" small icon :title="$t('Pilot.MissionDrawer.ReplayMissionTooltip')"><v-icon>mdi-replay</v-icon></v-btn>
      <v-spacer />
      <span>
        <v-btn class="mx-0" @click="changeValue(0)" :disabled="currentValue == 0" small icon :title="$t('Pilot.MissionDrawer.GoToFirstYoTooltip')"><v-icon >mdi-skip-previous</v-icon></v-btn>
        <v-btn class="mx-0" @click="goPrevYo(currentValue)" :disabled="currentValue == 0" small icon :title="$t('Pilot.MissionDrawer.GoToPreviousSurfacingYoTooltip')"><v-icon >mdi-chevron-double-left</v-icon></v-btn>        
        <v-btn class="mx-0" @click="changeValue(currentValue-1)" :disabled="currentValue == 0" small icon :title="$t('Pilot.MissionDrawer.GoToPreviousYoTooltip')"><v-icon >mdi-chevron-left</v-icon></v-btn>        
        <span style="display:inline-block;width:97px;text-align:center" v-if="currentDate=='Invalid Date'">{{$t('Pilot.MissionDrawer.Cycle')}} {{cycles[currentValue]}}</span><template v-else>{{currentDate | formatDate}}</template>
        <v-btn class="mx-0" @click="changeValue(currentValue+1)" :disabled="currentValue == dates.length-1" small icon :title="$t('Pilot.MissionDrawer.GoToNextYoTooltip')"><v-icon >mdi-chevron-right</v-icon></v-btn>
        <v-btn class="mx-0" @click="goNextYo(currentValue)" :disabled="currentValue == dates.length-1" small icon :title="$t('Pilot.MissionDrawer.GoToNextSurfacingYoTooltip')"><v-icon >mdi-chevron-double-right</v-icon></v-btn>
        <v-btn class="mx-0" @click="changeValue(dates.length-1)" :disabled="currentValue == dates.length-1" small icon :title="$t('Pilot.MissionDrawer.GoToLastYoTooltip')"><v-icon >mdi-skip-next</v-icon></v-btn>
      </span>            
    </v-layout>
  </div> 
</template>
<script lang="ts">
  import Vue from 'vue'  
  import { Watch} from 'vue-property-decorator'
  import Component from 'vue-class-component'  
  import { AloMission } from '@/models/alo/AloMission'    
import { MissionUiState } from '../../models/ui/MissionUiState'
  @Component({
    name: 'MissionTimeLine', 
    props:{
       mission:{
        type: AloMission
      },
      uiid:{
          type: String,
          required: true
      },
      endMissionMode:{
        type:Boolean,    
        default:false
      }
    }
  })
  export default class MissionTimeLine extends Vue {

    mission!:AloMission
    uiid!:string
    
    isPlaying = false
    currentValue = 0
    
    mounted(){
      this.checkIndex(this.timelineIndex)
    }
   
    get missionState() {  
      //retourne un MissionUiState        
      return this.$store.myGetters.uistatebyuiid(this.uiid) as MissionUiState
    }

    get timelineIndex(){
      return this.missionState.timelineIndex
    }

    get currentDate() {
      return this.dates[this.currentValue]
    }

    get dates() {
      return this.mission.yoArray.map(y => y.yoGpsDatTime);        
    }
    
    get cycles() {
      return this.mission.yoArray.map(y => y.yosCycle);        
    } 
    
    updateValue(val:number) {                
      this.currentValue = val
    }

    goPrevYo(val:number){
        let yo = null                
        let offset = 1
        while(val-offset >= 0 && (yo = this.mission.yoArray[val-offset]).isUnderWater){
          offset++;
        }        
        if(yo && !yo.isUnderWater)  this.changeValue(val - offset)
    }

    goNextYo(val:number){
        let yo = null              
        let offset = 1
        while(this.mission.yoArray.length > (val+offset) &&  (yo = this.mission.yoArray[val+offset]).isUnderWater){
          offset++;
        }        
        if(yo && !yo.isUnderWater) this.changeValue(val + offset)
    }

    changeValue(val:number) {                
      this.$store.myActions.UI_SELECT_TIMELINE_MISSION_INDEX({index: val, uiid:this.uiid})        
    }

    play() {
        if(this.isPlaying) {
          if(this.currentValue == this.dates.length - 1) {
            this.isPlaying = false
          }
          else{
            this.changeValue(this.currentValue+1)            
            setTimeout(() => this.play(),350)
          }     
        }
    }

    checkIndex(newIndex:number){
      this.currentValue = newIndex != -1? newIndex : this.dates.length-1
    }    
    
    beforeDestroy(){
       this.isPlaying = false
    }

    @Watch('isPlaying')
    onIsPlayingChanged(playing: boolean, oldPlaying: boolean) {      
      if(playing) {  
        //si on reviens au debut on attend que l'animation du curseur de la time line soit fini avant de lancer le play                      
        if(this.currentValue == this.dates.length - 1) {
          this.changeValue(0)
          setTimeout(() => this.play(),350)          
        } 
        else  {                     
          this.play()
        }
      }          
    }
     
    @Watch('timelineIndex')
    onTimelineIndexChanged(newIndex: number, oldIndex: number) {            
      this.checkIndex(newIndex)
    }        
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

/*.mdc-slider__pin{
  display: none!important;
}*/

</style>

<style scope>

</style>